import { gql } from '@apollo/client';

export const CREATE_NOTIFICATION_MUTATION = gql`
    mutation createNotification($input: CreateNotificationInput!) {
        result: createNotification(input: $input) {
            id
            isSticky
            isFeatured
            isPublished
            publishAt 
            unpublishAt 
            unfeatureAt
            weight
            brandIds
            locales {
                code
                name
                description
            }
        }
    } 
`;